import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { fmt } from './DenominationCountGrid';

const BreakdownTable = ({ title, entries }) => {
  const total = entries.reduce((sum, e) => sum + parseFloat(e.subtotal || 0), 0);

  return (
    <Box sx={{ mb: 0.75 }}>
      <Typography sx={{ fontSize: '0.6rem', fontWeight: 900, color: '#94A3B8', letterSpacing: '0.05em', mb: 0.25 }}>
        {title}
      </Typography>
      {entries.map((e) => (
        <Box key={e.denomination_id} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.15 }}>
          <Typography sx={{ fontSize: '0.65rem', color: '#64748B' }}>
            ₹{e.denomination_value} × {e.count}
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#1E293B', fontWeight: 600 }}>
            {fmt(e.subtotal)}
          </Typography>
        </Box>
      ))}
      <Divider sx={{ my: 0.4 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: '#1E293B' }}>Total</Typography>
        <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: '#1E293B' }}>{fmt(total)}</Typography>
      </Box>
    </Box>
  );
};

/**
 * Collapsible "View denomination breakdown" toggle + opening/closing tables,
 * rendered inside the SESSION card when require_denomination_counting is on
 * and the session has denomination entries.
 */
const DenominationBreakdown = ({ openingDenominations = [], closingDenominations = [], expanded, onToggle }) => {
  const hasOpening = openingDenominations.length > 0;
  const hasClosing = closingDenominations.length > 0;
  if (!hasOpening && !hasClosing) return null;

  return (
    <Box>
      <Box
        onClick={onToggle}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.4, cursor: 'pointer', userSelect: 'none' }}
      >
        <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#64748B' }}>
          View denomination breakdown
        </Typography>
        {expanded
          ? <ExpandLess sx={{ fontSize: 14, color: '#64748B' }} />
          : <ExpandMore sx={{ fontSize: 14, color: '#64748B' }} />}
      </Box>

      {expanded && (
        <Box sx={{ bgcolor: '#FFF', border: '1px solid #E2E8F0', borderRadius: '8px', p: 1, mt: 0.5 }}>
          {hasOpening && <BreakdownTable title="OPENING" entries={openingDenominations} />}
          {hasClosing && <BreakdownTable title="CLOSING" entries={closingDenominations} />}
        </Box>
      )}
    </Box>
  );
};

export default DenominationBreakdown;
